import instance from '../Config/Config';



export const UPDATE_URL = "edit-profile"
export const COMPANY_EDIT = "company_info"
export const AGENCY_EDIT = "agency_info"
export const VENDOR_EDIT = "vendor_info"

export const ACCOUN_DETAILS_URL = "account_details"
// export const KYC_URL = "kyc"
// export const UPDATE_KYC_URL = "edit_kyc"
export const NOTIFICATION = "notifications"
export const PROFILE_URL = "get_profile"
export const COMMISION_URL = "agent_commisions"
export const CHECKROLE = "check_role"
export const PAYOUTLIST_URL = "payout_list"
export const REQUEST_PAYOUT_URL = "request_payout"
//added
export const CAREER_URL = "career"
export const FRANCHISE_AVAILABLE_STOCK = "franchise/available-stock"
export const FRANCHISE_STOCK_HISTORY = "franchise/stock-history"
export const FRANCHISE_OUT_OF_STOCK = "franchise/out-of-stock"
export const FRANCHISE_DASHBOARD = "franchise-dashboard"
export const FRANCHISE_OUT = "franchise_product"

export const DEDUCT_STOCK_URL = "franchise/deduct-stock"

export const update_fun = async (value) => {
    const response = await instance.post(`${UPDATE_URL}`, value);
    return response.data
}


//added

export const career_fun = async (value) => {
    const response = await instance.post(`${CAREER_URL}`, value);
    return response.data
}
//



export const comapny_edit_fun = async (value) => {
    const response = await instance.post(`${COMPANY_EDIT}`, value);
    return response.data
}

export const agency_edit_fun = async (value) => {
    const response = await instance.post(`${AGENCY_EDIT}`, value);
    return response.data
}

export const vendor_edit_fun = async (value) => {
    const response = await instance.post(`${VENDOR_EDIT}`, value);
    return response.data
}

export const accountdetails_fun = async (value) => {
    const response = await instance.post(`${ACCOUN_DETAILS_URL}`, value)
    return response.data
}


export const request_payout = async (value) => {
    const response = await instance.post(`${REQUEST_PAYOUT_URL}`, value)
    return response.data
}


export const getprofile_fun = async () => {
    const response = await instance.get(`${PROFILE_URL}`)
    return response?.data
}

export const getCommisionApi = async () => {
    const response = await instance.get(`${COMMISION_URL}`)
    return response?.data
}

export const getPayListApi = async () => {
    const response = await instance.get(`${PAYOUTLIST_URL}`)
    return response?.data
}

// export const kyc_fun = async (value) => {
//     const response = await instance.post(`${KYC_URL}`, value)
//     return response.data

// }

// export const editkyc_fun = async (value) => {
//     const response = await instance.post(`${UPDATE_KYC_URL}`, value)
//     return response.data

// }

export const notification_fun = async () => {
    const response = await instance.get(`${NOTIFICATION}`)
    return response?.data
}



export const checkUserRoleApi = async (role, phone, phone_code) => {
    const response = await instance.get(`${CHECKROLE}?phone=${phone}&role=${role}&phone_number_code=${phone_code}`)
    return response?.data
}

export const getAvailableStockApi = async (page = 1) => {
    const response = await instance.get(`${FRANCHISE_AVAILABLE_STOCK}?page=${page}`);
    return response?.data;
}

export const getStockHistoryApi = async (page = 1) => {
    const response = await instance.get(`${FRANCHISE_STOCK_HISTORY}?page=${page}`);
    return response?.data;
}

export const getOutOfStockApi = async (page = 1) => {
    const response = await instance.get(`${FRANCHISE_OUT_OF_STOCK}?page=${page}`);
    return response?.data;
}

export const getFranchiseDashboardApi = async (id) => {
    const response = await instance.get(`${FRANCHISE_DASHBOARD}/${id}`);
    return response?.data;
}

export const getProductStockApi = async (id, page = 1) => {
    const response = await instance.get(`product-stock/${id}?page=${page}`);
    return response?.data;
}

export const getFranchiseOutApi = async (id, page = 1) => {
    const response = await instance.get(`product-stock/${id}?page=${page}`);
    return response?.data;
}

export const getFranchiseProductApi = async () => {
    const response = await instance.get(`${FRANCHISE_OUT}`);
    return response?.data;
}

export const getFranchiseProductListByIdApi = async (id) => {
    const response = await instance.get(`franchise_product_list/${id}`);
    return response?.data;
}

export const deductStockApi = async (data) => {
    const response = await instance.post(`${DEDUCT_STOCK_URL}`, data);
    return response.data;
}

export const FRANCHISE_ORDER_LIST = "franchise_order_list";

export const getFranchiseOrderListApi = async () => {
    const response = await instance.get(`${FRANCHISE_ORDER_LIST}`);
    return response?.data;
}

export const FRANCHISE_ORDER_DETAILS = "franchise_order_details";

export const getFranchiseOrderDetailsApi = async (id) => {
    const response = await instance.get(`${FRANCHISE_ORDER_DETAILS}/${id}`);
    return response?.data;
}

export const FRANCHISE_UPDATE_DELIVERY_STATUS = "franchise_update_delivery_status";

export const updateFranchiseDeliveryStatusApi = async (orderId, status) => {
    const response = await instance.get(`${FRANCHISE_UPDATE_DELIVERY_STATUS}?order_id=${orderId}&status=${status}`);
    return response?.data;
}
